import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'usFormat' })
export class phoneFormatPipe implements PipeTransform {
    transform(tel: string): any {
        if (!tel) { return tel; }
        return tel.replace(/\D+/g, '');
    }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/pipesFiles/phoneFormat.pipe.ts